export default __webpack_public_path__ + "static/media/user.d1a7045e.d1a7045e.png";